import { render, staticRenderFns } from "./List02.vue?vue&type=template&id=6bb5fd64&scoped=true&"
import script from "./list02.js?vue&type=script&lang=js&"
export * from "./list02.js?vue&type=script&lang=js&"
import style0 from "./List02.vue?vue&type=style&index=0&id=6bb5fd64&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb5fd64",
  null
  
)

export default component.exports